<template>
    <div class="nav-mobile">
        <q-icon
            class="mobi-icon"
            name="menu"
            size="28px"
            @click="mobiMenu = !mobiMenu"
        ></q-icon>
        <q-menu
            v-model="mobiMenu"
            content-class="mobi-menu"
            target=".header-wrap"
            transition-show="slide-down"
            transition-hide="slide-up"
            no-parent-event
            square
            fit
        >
            <q-list>
                <div class="row">
                    <div class="main-nav col-grow">
                        <MobiLangSwitcher />
                        <q-separator />
                        <q-item v-close-popup clickable>
                            <q-item-section>
                                <router-link to="/areas">
                                    {{ $tc('general.training_areas', 2) }}
                                </router-link>
                            </q-item-section>
                        </q-item>
                        <q-item v-close-popup clickable>
                            <q-item-section>
                                <router-link to="/partners">
                                    {{ $tc('general.partners', 2) }}
                                </router-link>
                            </q-item-section>
                        </q-item>
                        <q-expansion-item
                            v-model="expandAbout"
                            class="expansion-menu"
                            expand-separator
                        >
                            <template v-slot:header>
                                <div class="expansion-header">
                                    {{ $t('general.about_us') }}
                                </div>
                            </template>
                            <q-list>
                                <q-item
                                    v-close-popup
                                    class="expansion-option"
                                    to="/about"
                                    clickable
                                    exact
                                >
                                    <q-item-section>{{
                                        $t('general.about_cfma')
                                    }}</q-item-section>
                                </q-item>
                                <q-item
                                    v-close-popup
                                    class="expansion-option"
                                    to="/about/history"
                                    clickable
                                >
                                    <q-item-section>{{
                                        $t('general.history')
                                    }}</q-item-section>
                                </q-item>
                                <q-item
                                    v-close-popup
                                    class="expansion-option"
                                    to="/about/team"
                                    clickable
                                >
                                    <q-item-section
                                        >{{
                                            $t('general.team')
                                        }}
                                        CFMA</q-item-section
                                    >
                                </q-item>
                                <q-item
                                    v-close-popup
                                    class="expansion-option"
                                    to="/about/certificates-awards"
                                    clickable
                                >
                                    <q-item-section
                                        >{{ $t('general.certifications') }} /
                                        {{
                                            $t('general.awards')
                                        }}</q-item-section
                                    >
                                </q-item>
                                <q-item
                                    v-close-popup
                                    class="expansion-option"
                                    to="/about/mission"
                                    clickable
                                >
                                    <q-item-section>{{
                                        $t('general.mission-vision-values')
                                    }}</q-item-section>
                                </q-item>
                            </q-list>
                        </q-expansion-item>
                        <q-separator />
                        <template v-if="!user">
                            <q-item v-close-popup clickable>
                                <q-item-section>
                                    <router-link to="/cart">
                                        {{ $t('general.shopping_cart') }} ({{
                                            cart.length
                                        }})
                                    </router-link>
                                </q-item-section>
                            </q-item>
                            <q-item v-close-popup clickable>
                                <q-item-section>
                                    <router-link to="/login" class="login">
                                        {{ $t('actions.login') }}
                                    </router-link>
                                </q-item-section>
                            </q-item>
                            <q-item v-close-popup clickable>
                                <q-item-section>
                                    <router-link to="/sign-up" class="sign-up">
                                        {{ $t('actions.signup') }}
                                    </router-link>
                                </q-item-section>
                            </q-item>
                        </template>
                    </div>
                    <template v-if="user">
                        <div class="profile-nav row col-12 items-center">
                            <div class="col-12 text-center">
                                <q-item v-close-popup clickable>
                                    <q-item-section>
                                        <router-link to="/profile">
                                            <q-avatar
                                                size="50px"
                                                font-size="50px"
                                                class="q-mx-sm q-mt-sm"
                                            >
                                                <img
                                                    class="avatar-border"
                                                    :src="profileImage"
                                                />
                                            </q-avatar>
                                            <h6>{{ userFirstAndLastName }}</h6>
                                            <span>{{ user.ocuupation }}</span>
                                        </router-link>
                                    </q-item-section>
                                </q-item>
                            </div>
                        </div>
                        <q-separator class="q-my-md" />
                        <div class="col-12 quick-link-icons justify-between">
                            <q-btn
                                class="q-mx-sm"
                                :to="{ name: 'Cart' }"
                                flat
                                round
                                color="primary"
                                icon="eva-shopping-cart-outline"
                            >
                                <q-badge
                                    v-if="cart.length > 0"
                                    color="red"
                                    floating
                                >
                                    {{ cart.length }}
                                </q-badge>
                                <q-tooltip>
                                    {{ $t('general.shopping_cart') }}
                                </q-tooltip>
                            </q-btn>
                            <q-btn
                                class="q-mx-sm"
                                :to="{ name: 'Wishlist' }"
                                flat
                                round
                                color="primary"
                                icon="favorite_border"
                            >
                                <q-badge
                                    v-if="wishlistCounter > 0"
                                    color="red"
                                    floating
                                >
                                    {{ wishlistCounter }}
                                </q-badge>
                                <q-tooltip>
                                    {{ $t('general.wishlist') }}
                                </q-tooltip>
                            </q-btn>
                            <!-- <q-btn
                                class="q-mx-sm"
                                :to="{ name: 'Notifications' }"
                                flat
                                round
                                color="primary"
                                icon="eva-bell-outline"
                            >
                                <q-badge
                                    v-if="notifications.length >= 1"
                                    color="red"
                                    floating
                                    >>{{ notifications.length }}</q-badge
                                >
                                <q-tooltip>
                                    {{ $t('general.notifications') }}
                                </q-tooltip>
                            </q-btn> -->
                            <q-btn
                                class="q-mx-sm"
                                flat
                                round
                                color="primary"
                                icon="logout"
                                @click="logout"
                            >
                                <q-tooltip>
                                    {{ $t('actions.logout') }}
                                </q-tooltip>
                            </q-btn>
                        </div>
                    </template>
                </div>
            </q-list>
        </q-menu>
    </div>
</template>

<script>
//import notificationsService from '@/services/modules/notifications'
import MobiLangSwitcher from '@/components/MobiLangSwitcher'
import authenticationService from '@/services/authentication'
import picturesService from '@/services/pictures'
import encoders from '@/helpers/encoders'
import store from '@/store'
import _ from 'lodash'
import currencies from '@/local-shared/mixins/currencies'

const loadingKeys = {
    fetchingPicture: 'fetching-picture',
    //fetchingNotifications: 'fetching-notifications',
}

export default {
    components: {
        MobiLangSwitcher,
    },

    mixins: [currencies],

    data() {
        return {
            mobiMenu: false,
            expandAbout: false,
            profileImage: '',
            //notifications: [],
        }
    },

    computed: {
        cart() {
            return store.getters['cart/cart']
        },

        wishlistCounter() {
            return store.getters['wishlist/wishlistCount']
        },

        isAuthenticated() {
            return store.getters['session/isAuthenticated']
        },

        isLoading() {
            return this.isFetchingPicture || this.isFetchingNotifications
        },

        isFetchingPicture() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPicture
            ).length
        },

        isFetchingNotifications() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingNotifications
            ).length
        },

        user() {
            let user
            if (this.isAuthenticated) {
                user = store.getters['session/user']
            }
            return user
        },

        userFirstAndLastName() {
            if (this.user) {
                let nameWords = _.words(this.user.first_name)
                return nameWords.length == 1
                    ? nameWords[0]
                    : nameWords[0] + ' ' + nameWords[nameWords.length - 1]
            } else {
                return ''
            }
        },
    },

    async created() {
        if (this.user) {
            //this.fetchNotifications()
            if (this.user.user_picture_id != null) {
                await this.fetchPicture(this.user.user_picture_id)
            } else {
                this.profileImage = require('@/assets/images/user_avatar.png')
            }
        }
    },

    methods: {
        async logout() {
            await authenticationService.logout()
            store.dispatch('cart/updateLibary', [])
            store.dispatch('locale/updateLocale', {})
            store.dispatch('cart/emptyCart')
            store.dispatch('wishlist/updateCount', 0)
            if (this.$route.name !== 'Home') {
                this.$router.push({ name: 'Home' })
            }
            this.initCurrency()
        },

        async fetchPicture(pictureId) {
            this.loadingAdd(loadingKeys.fetchingPicture)

            let response = await picturesService.retrieveById(pictureId)

            if (response.status === 200) {
                this.profileImage = encoders.arrayBufferToBase64(response)
            } else {
                this.notifyError(response)
            }
            this.loadingRemove(loadingKeys.fetchingPicture)
        },

        // async fetchNotifications() {
        //     this.loadingAdd(loadingKeys.fetchingNotifications)

        //     let parameters = {
        //         filter: {
        //             recipient_id: this.user.id,
        //         },
        //     }

        //     let response = await notificationsService.retrieve(parameters)

        //     if (response.status === 200) {
        //         this.notifications = response.data.results
        //     } else {
        //         this.notifyError(response)
        //     }

        //     this.loadingRemove(loadingKeys.fetchingNotifications)
        // },
    },
}
</script>
